export default "__VITE_ASSET__hJ39IpMH__"